const prod = {
  API_BASE: "https://spring-field-7795.fly.dev",
};

const dev = {
  API_BASE: "http://localhost:8080",
};

export const config = process.env.NODE_ENV === "development" ? dev : prod;
